// extracted by mini-css-extract-plugin
export default {"companyContainer":"gR-z","companyImage":"hR-z","container":"iR-z","heading":"jR-z","darkText":"kR-z","smallHeading":"lR-z","darkBackground":"mR-z","whiteBackground":"nR-z"};